import { render, staticRenderFns } from "./TaxesAndFees.vue?vue&type=template&id=534831fc&scoped=true"
import script from "./TaxesAndFees.vue?vue&type=script&lang=js"
export * from "./TaxesAndFees.vue?vue&type=script&lang=js"
import style0 from "./TaxesAndFees.vue?vue&type=style&index=0&id=534831fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534831fc",
  null
  
)

export default component.exports